import React, { useEffect, useState } from "react";

import { useMarket } from "../../hooks/useMarket";
import { useCore } from "../../hooks/useCore";
import classNames from "classnames";
import { TransformWrapper, TransformComponent } from "@pronestor/react-zoom-pan-pinch";
import { Rating } from 'react-simple-star-rating';


import { formatCurrency, condenseZeros, formatPercent, formatCurrencyScale } from "../../utils/currency";

var parse = require('html-react-parser');

export function NFTItem({ nft, ca, passClick, includeInfo, type=null }) {

    const { fullscreen, modalVisible, handleModalVisible, qrModal, handleQrModal, handleQrurl, handleModalTitle } = useCore();

    const [imageUrl, setImageUrl] = useState('');
    const [mediaLoaded, setMediaLoaded] = useState(false);

    const [rating, setRating] = useState(3); // initial rating value


    useEffect(() => {
        // console.log("NFT Image",nft.metadata.image);
        let img = nft.metadata?.image ? nft.metadata.image : nft.image_url;
        let i = img !== undefined ? img.replace("ipfs://","https://ipfs.io/ipfs/") : '';
        setImageUrl(i);
    }, [] );

    const handleClick = () => {
        passClick(nft.token_id);
    }

    const openOpenSea = (e) => {
        e.preventDefault();
        e.stopPropagation();
        window.open(
            `https://opensea.io/assets/ethereum/${ca}/${nft.token_id}`,
            'opensea'
            // 'toolbar=0,status=0,width=548,height=325'
        );
    }

    const openEtherscan = (e) => {
        e.preventDefault();
        e.stopPropagation();
        window.open(
            `https://etherscan.io/token/${nft.token_address}?a=${nft.token_id}#inventory`,
            'etherscan'
            // 'toolbar=0,status=0,width=548,height=325'
        );
    }

    const showQRModal = (e) => {
        e.preventDefault();
        e.stopPropagation();
        handleModalTitle(nft.name + ' - #' + nft.token_id);
        let qu = `${process.env.REACT_APP_ARTEMIS_URL_IP}/assets/${nft.token_address}/${nft.token_id}`;
        console.log(qu);
        handleQrurl(qu);
        handleModalVisible(true);
        handleQrModal(true);
    }

    const openQRUrl = (e) => {
        e.preventDefault();
        e.stopPropagation();


        let qu = `${process.env.REACT_APP_ARTEMIS_URL_IP}/assets/${nft.token_address}/${nft.token_id}`;
        window.open(
            qu,
            'qru'
            // 'toolbar=0,status=0,width=548,height=325'
        );
    }

    const handleMediaLoaded = () => {
        setMediaLoaded(true)
    }




    const handleRating = (rate: number) => {
        setRating(rate)

    }


    //
    // let iurl = nft.metadata.image;
    // console.log(iurl);
    // const imageurl = nft && nft.metadata ? iurl.replace("ifps://","https://ipfs.io/ipfs/") : '';

    return (

        <div className={classNames('nft-item', 'transition', !includeInfo && 'full')}>

            {/*<video autoPlay muted className="nft-art" src={imageUrl}/>*/}
            { imageUrl.indexOf("gateway.pinata") < 0 && (
                <div onClick={handleClick} className="nft-art-container">

                    {!mediaLoaded && imageUrl.indexOf(".mp4") < 0 && (
                        <div className="loader-spinner"/>
                    )}


                    { imageUrl.indexOf(".mp4") > -1 ? (
                        <video playsInline autoPlay muted controls onLoadedData={handleMediaLoaded} className="nft-art" />
                    ) : type=="static" || fullscreen ? (
                        <img onLoad={handleMediaLoaded} className="nft-art transition" src={imageUrl}/>
                    ) : (

                        <TransformWrapper
                            wheel={{step: 0.04}}
                            limitToBounds={true}

                            centerZoomedOut={true}
                        >
                            <TransformComponent>
                                <img onLoad={handleMediaLoaded} className="nft-art transition" src={imageUrl}/>
                            </TransformComponent>
                        </TransformWrapper>

                    )}
                </div>
            )}


            { includeInfo && (
                <>
                    <div className="coin-meta">
                        <div>
                            {nft.token_id.length > 7 ? (

                                    <p className="coin-name">{nft.metadata.name}</p>

                            ):(
                                <>
                                    <p className="coin-name">{nft.name}</p>
                                    <p className="coin-symbol"><span className="mute">#</span>{nft.token_id}</p>
                                </>
                            )}
                        </div>




                        <div className="coin-links">

                            <div onClick={openEtherscan} className="coin-link">
                                <div className="svg-icon">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="293.775" height="293.667" viewBox="0 0 293.775 293.667">
                                      <g id="etherscan-logo-light-circle" transform="translate(-219.378 -213.333)">
                                        <path id="Path_1" data-name="Path 1" d="M280.433,353.152A12.45,12.45,0,0,1,292.941,340.7l20.737.068a12.467,12.467,0,0,1,12.467,12.467v78.414c2.336-.692,5.332-1.43,8.614-2.2a10.389,10.389,0,0,0,8.009-10.11V322.073a12.469,12.469,0,0,1,12.467-12.47h20.779a12.47,12.47,0,0,1,12.467,12.47v90.276s5.2-2.106,10.269-4.245a10.408,10.408,0,0,0,6.353-9.577V290.9a12.466,12.466,0,0,1,12.465-12.467h20.779A12.468,12.468,0,0,1,450.815,290.9v88.625c18.014-13.055,36.271-28.758,50.759-47.639a20.926,20.926,0,0,0,3.185-19.537,146.6,146.6,0,0,0-136.644-99.006c-81.439-1.094-148.744,65.385-148.736,146.834a146.371,146.371,0,0,0,19.5,73.45,18.56,18.56,0,0,0,17.707,9.173c3.931-.346,8.825-.835,14.643-1.518a10.383,10.383,0,0,0,9.209-10.306V353.152" transform="translate(0 0)" />
                                        <path id="Path_2" data-name="Path 2" d="M244.417,398.641A146.808,146.808,0,0,0,477.589,279.9c0-3.381-.157-6.724-.383-10.049-53.642,80-152.686,117.405-232.79,128.793" transform="translate(35.564 80.269)" fill="#bfcfda"/>
                                      </g>
                                    </svg>

                                </div>
                            </div>
                            <div onClick={openOpenSea} className="coin-link">
                                <div className="svg-icon">
                                    <svg width="90" height="90" viewBox="0 0 90 90" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M45 0C20.151 0 0 20.151 0 45C0 69.849 20.151 90 45 90C69.849 90 90 69.849 90 45C90 20.151 69.858 0 45 0ZM22.203 46.512L22.392 46.206L34.101 27.891C34.272 27.63 34.677 27.657 34.803 27.945C36.756 32.328 38.448 37.782 37.656 41.175C37.323 42.57 36.396 44.46 35.352 46.206C35.217 46.458 35.073 46.71 34.911 46.953C34.839 47.061 34.713 47.124 34.578 47.124H22.545C22.221 47.124 22.032 46.773 22.203 46.512ZM74.376 52.812C74.376 52.983 74.277 53.127 74.133 53.19C73.224 53.577 70.119 55.008 68.832 56.799C65.538 61.38 63.027 67.932 57.402 67.932H33.948C25.632 67.932 18.9 61.173 18.9 52.83V52.56C18.9 52.344 19.08 52.164 19.305 52.164H32.373C32.634 52.164 32.823 52.398 32.805 52.659C32.706 53.505 32.868 54.378 33.273 55.17C34.047 56.745 35.658 57.726 37.395 57.726H43.866V52.677H37.467C37.143 52.677 36.945 52.299 37.134 52.029C37.206 51.921 37.278 51.813 37.368 51.687C37.971 50.823 38.835 49.491 39.699 47.97C40.284 46.944 40.851 45.846 41.31 44.748C41.4 44.55 41.472 44.343 41.553 44.145C41.679 43.794 41.805 43.461 41.895 43.137C41.985 42.858 42.066 42.57 42.138 42.3C42.354 41.364 42.444 40.374 42.444 39.348C42.444 38.943 42.426 38.52 42.39 38.124C42.372 37.683 42.318 37.242 42.264 36.801C42.228 36.414 42.156 36.027 42.084 35.631C41.985 35.046 41.859 34.461 41.715 33.876L41.661 33.651C41.553 33.246 41.454 32.868 41.328 32.463C40.959 31.203 40.545 29.97 40.095 28.818C39.933 28.359 39.753 27.918 39.564 27.486C39.294 26.82 39.015 26.217 38.763 25.65C38.628 25.389 38.52 25.155 38.412 24.912C38.286 24.642 38.16 24.372 38.025 24.111C37.935 23.913 37.827 23.724 37.755 23.544L36.963 22.086C36.855 21.888 37.035 21.645 37.251 21.708L42.201 23.049H42.219C42.228 23.049 42.228 23.049 42.237 23.049L42.885 23.238L43.605 23.436L43.866 23.508V20.574C43.866 19.152 45 18 46.413 18C47.115 18 47.754 18.288 48.204 18.756C48.663 19.224 48.951 19.863 48.951 20.574V24.939L49.482 25.083C49.518 25.101 49.563 25.119 49.599 25.146C49.725 25.236 49.914 25.38 50.148 25.56C50.337 25.704 50.535 25.884 50.769 26.073C51.246 26.46 51.822 26.955 52.443 27.522C52.605 27.666 52.767 27.81 52.92 27.963C53.721 28.71 54.621 29.583 55.485 30.555C55.728 30.834 55.962 31.104 56.205 31.401C56.439 31.698 56.7 31.986 56.916 32.274C57.213 32.661 57.519 33.066 57.798 33.489C57.924 33.687 58.077 33.894 58.194 34.092C58.554 34.623 58.86 35.172 59.157 35.721C59.283 35.973 59.409 36.252 59.517 36.522C59.85 37.26 60.111 38.007 60.273 38.763C60.327 38.925 60.363 39.096 60.381 39.258V39.294C60.435 39.51 60.453 39.744 60.471 39.987C60.543 40.752 60.507 41.526 60.345 42.3C60.273 42.624 60.183 42.93 60.075 43.263C59.958 43.578 59.85 43.902 59.706 44.217C59.427 44.856 59.103 45.504 58.716 46.098C58.59 46.323 58.437 46.557 58.293 46.782C58.131 47.016 57.96 47.241 57.816 47.457C57.609 47.736 57.393 48.024 57.168 48.285C56.97 48.555 56.772 48.825 56.547 49.068C56.241 49.437 55.944 49.779 55.629 50.112C55.449 50.328 55.251 50.553 55.044 50.751C54.846 50.976 54.639 51.174 54.459 51.354C54.144 51.669 53.892 51.903 53.676 52.11L53.163 52.569C53.091 52.641 52.992 52.677 52.893 52.677H48.951V57.726H53.91C55.017 57.726 56.07 57.339 56.925 56.61C57.213 56.358 58.482 55.26 59.985 53.604C60.039 53.541 60.102 53.505 60.174 53.487L73.863 49.527C74.124 49.455 74.376 49.644 74.376 49.914V52.812V52.812Z"/>
                                    </svg>

                                </div>
                            </div>

                            <div onClick={showQRModal} className="coin-link">
                                <div className="svg-icon">
                                <svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1000 1000">
                                <g><path d="M377.1,377.1H10V10h367.1V377.1z M78.6,308.5h229.8V78.6H78.6V308.5L78.6,308.5z"/><path d="M132.4,132.4h122.4v122.4H132.4V132.4z"/><path d="M377.1,990H10V621.8h367.1V990z M78.6,921.4h229.8v-231H78.6V921.4L78.6,921.4z"/><path d="M132.4,745.3h122.4v121.2H132.4V745.3z"/><path d="M990,377.1H621.8V10H990V377.1z M690.4,308.5h231V78.6h-231V308.5z"/><path d="M745.3,132.4h121.2v122.4H745.3V132.4z"/><path d="M10,377.1h122.4v123.5H10V377.1z"/><path d="M254.7,500.6h122.4v121.2H254.7V500.6L254.7,500.6z"/><path d="M500.6,10h121.2v122.4H500.6V10z"/><path d="M377.1,254.7h123.5v122.4H377.1V254.7z"/><path d="M500.6,866.5h121.2V990H500.6V866.5z"/><path d="M745.3,866.5H990V990H745.3V866.5z"/><path d="M500.6,621.8h244.7v123.5H500.6V621.8z"/><path d="M745.3,621.8h121.2v244.7H745.3V621.8z"/><path d="M855.1,621.8H990v123.5H855.1V621.8z"/><path d="M500.6,377.1h121.2v123.5H500.6V377.1z"/><path d="M621.8,500.6h123.5v121.2H621.8V500.6L621.8,500.6z"/><path d="M745.3,377.1h121.2v123.5H745.3V377.1z"/><path d="M866.5,500.6H990v121.2H866.5V500.6L866.5,500.6z"/></g>
                                </svg>

                                </div>
                            </div>


                            <div onClick={openQRUrl} className="coin-link">
                                <div className="svg-icon">
                                <svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1000 1000">
                                <g><path d="M377.1,377.1H10V10h367.1V377.1z M78.6,308.5h229.8V78.6H78.6V308.5L78.6,308.5z"/><path d="M132.4,132.4h122.4v122.4H132.4V132.4z"/><path d="M377.1,990H10V621.8h367.1V990z M78.6,921.4h229.8v-231H78.6V921.4L78.6,921.4z"/><path d="M132.4,745.3h122.4v121.2H132.4V745.3z"/><path d="M990,377.1H621.8V10H990V377.1z M690.4,308.5h231V78.6h-231V308.5z"/><path d="M745.3,132.4h121.2v122.4H745.3V132.4z"/><path d="M10,377.1h122.4v123.5H10V377.1z"/><path d="M254.7,500.6h122.4v121.2H254.7V500.6L254.7,500.6z"/><path d="M500.6,10h121.2v122.4H500.6V10z"/><path d="M377.1,254.7h123.5v122.4H377.1V254.7z"/><path d="M500.6,866.5h121.2V990H500.6V866.5z"/><path d="M745.3,866.5H990V990H745.3V866.5z"/><path d="M500.6,621.8h244.7v123.5H500.6V621.8z"/><path d="M745.3,621.8h121.2v244.7H745.3V621.8z"/><path d="M855.1,621.8H990v123.5H855.1V621.8z"/><path d="M500.6,377.1h121.2v123.5H500.6V377.1z"/><path d="M621.8,500.6h123.5v121.2H621.8V500.6L621.8,500.6z"/><path d="M745.3,377.1h121.2v123.5H745.3V377.1z"/><path d="M866.5,500.6H990v121.2H866.5V500.6L866.5,500.6z"/></g>
                                </svg>

                                </div>
                            </div>


                            <div className="coin-link">
                                <div className="icon-button-heart"/>
                            </div>

                            <div className="coin-link">
                                <div className="icon-button-bookmark"/>
                            </div>

                            <div className="coin-link">
                                <div className="icon-like"/>
                            </div>

                            <div className="coin-link">
                                <div className="icon-bookmark"/>
                            </div>


                        </div>
                    </div>
                    <Rating
                    onClick={handleRating}
                    // allowHalfIcon={true}
                    // ratingValue={rating}
                    initialValue={rating}
                    size={16}/>






                </>
            )}

        </div>
    )
}
